module.exports = __webpack_public_path__ + "images/emoji/love_hotel.fdce2d2143b7ee26e95d.png";